import React, { createContext, useContext } from 'react';

/** Refetch the current lazy-loaded users list (e.g. All Users). */
export type UsersListRefetchFn = () => void | Promise<void>;

const UsersListRefreshContext = createContext<UsersListRefetchFn | null>(null);

export function UsersListRefreshProvider({
  children,
  refetch,
}: {
  children: React.ReactNode;
  refetch: UsersListRefetchFn;
}) {
  return (
    <UsersListRefreshContext.Provider value={refetch}>
      {children}
    </UsersListRefreshContext.Provider>
  );
}

/** Present only under pages that wrap the list with `UsersListRefreshProvider`. */
export function useOptionalUsersListRefresh() {
  return useContext(UsersListRefreshContext);
}
